import { Booking } from 'types/Booking';

export interface BookingsState {
    booking?: Booking;
    status: BookingsStatus;
    loading: boolean;
}

export enum BookingsStatus {
    Initial,

    CreateStart,
    CreateSuccess,

    CreateDepositStart,
    CreateDepositSuccess,

    UpdateStart,
    UpdateSuccess,

    FetchingSiblings,
    FetchSiblingsSuccess,

    Error
}
